<template>
  <div>
    <v-simple-table class="ma-4 produtos-table">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left" style="min-width: 400px">Produto</th>
          <th class="text-left" style="min-width: 30px">Quantidade</th>
          <th style="min-width: 60px">Unidade de medida</th>
          <th style="min-width: 200px">Especificação</th>
          <th style="min-width: 138px"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(produto, index) in cotacao.produtos"
            :key="produto.$$id"
            style="height: 60px">
          <td class="px-1">
            <px-autocomplete-produto
              dense
              required
              show-details
              :truncate-value="25"
              menu-props="auto"
              :clearable="false"
              v-model="produto.produto"
              :error="$v.cotacao.produtos.$each[index].produto.$error"
              @blur="$v.cotacao.produtos.$each[index].produto.$touch()"
              class="required rounded-tag-small"
              base-path="/produtos/page"
              @change="onChange(produto, index)"/>
          </td>
          <td class="px-1">
            <px-input-decimal-number
              dense
              required
              label="Quantidade"
              class="required rounded-tag-small"
              :precision="getPrecision(produto.produto)"
              :error="$v.cotacao.produtos.$each[index].quantidade.$error"
              @blur="$v.cotacao.produtos.$each[index].quantidade.$touch()"
              v-model="produto.quantidade"/>
          </td>
          <td class="px-1">
            <px-autocomplete-unidade-medida
              dense
              required
              :only-open="false"
              :clearable="false"
              class="required rounded-tag-small"
              :error="$v.cotacao.produtos.$each[index].unidadeMedida.id.$error"
              @blur="$v.cotacao.produtos.$each[index].unidadeMedida.id.$touch()"
              v-model="produto.unidadeMedida"/>
          </td>
          <td class="px-1">
            <v-textarea
              outlined
              auto-grow
              dense
              hide-details
              v-model="produto.especificacaoProduto"
              label="Especificação"
              counter="1500"
              rows="1"
              class="rounded-tag-small"/>
          </td>
          <td class="px-1">
            <px-cadastro-produto-observacoes :produto="produto"/>
            <px-cadastro-produto-campos-adicionais :produto="produto"/>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" @click="duplicar(produto)">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Copiar produto</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" @click="removeProduto(index)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Remover produto</span>
            </v-tooltip>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-row dense>
      <v-col cols="12" class="text-right">
        <v-btn small color="primary" class="rounded-tag-small normal-btn-text elevation-0"
               @click="adicionarProduto">
          <v-icon small>mdi-plus</v-icon>
          Produto
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             :disabled="$v.$invalid || hasFileLoading || hasQuantidadeProduto"
             @click="next">
        Continuar
      </v-btn>
      <v-btn text @click="previous" class="normal-btn-text">Voltar</v-btn>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isEmpty, uniqueId } from 'lodash';
import { required } from 'vuelidate/lib/validators';
import { getPrecision } from '@/utils/produto-utils';

const initalState = () => ({
  produto: null,
  quantidade: null,
  unidadeMedida: {
    id: null,
    descricao: null,
  },
  arquivos: [],
  especificacaoProduto: null,
  observacaoExterna: null,
  observacaoInterna: null,
  centroCusto: null,
  projeto: null,
  $$hasFileLoading: false,
});

export default {
  props: {
    cotacao: Object,
  },
  methods: {
    next() {
      this.$emit('next');
    },
    previous() {
      this.$emit('previous');
    },
    idGenerator() {
      return uniqueId();
    },
    onChange(produto, index) {
      const currentProduto = this.cotacao.produtos[index];
      currentProduto.especificacaoProduto = this.getEspecificacao(produto);
      currentProduto.unidadeMedida = this.getUnidadeMedida(produto);
      currentProduto.arquivos = this.getArquivos(produto);
      currentProduto.observacaoExterna = this.getObservacaoExterna(produto);
      currentProduto.observacaoInterna = this.getObservacaoInterna(produto);
    },
    getUnidadeMedida(produto) {
      return produto.produto ? { ...produto.produto.unidadeMedida } : null;
    },
    getEspecificacao(produto) {
      if (produto.especificacaoProduto) {
        return produto.especificacaoProduto;
      }
      return produto.produto ? produto.produto.especificacao : null;
    },
    getArquivos(produto) {
      if (produto.arquivos && produto.arquivos.length) {
        return produto.arquivos;
      }
      return produto.produto ? produto.produto.arquivos : [];
    },
    getObservacaoExterna(produto) {
      if (produto.observacaoExterna) {
        return produto.observacaoExterna;
      }
      return produto.produto ? produto.produto.observacaoExterna : '';
    },
    getObservacaoInterna(produto) {
      if (produto.observacaoInterna) {
        return produto.observacaoInterna;
      }
      return produto.produto ? produto.produto.observacaoInterna : null;
    },
    duplicar(produto) {
      const newProduto = {
        ...produto,
        $$id: this.idGenerator(),
        quantidade: produto.quantidade,
      };
      this.cotacao.produtos.push(cloneDeep(newProduto));
    },
    adicionarProduto() {
      this.cotacao.produtos.push({
        ...initalState(),
        $$id: this.idGenerator(),
        centroCusto: this.cotacao.centroCusto ?? null,
        projeto: this.cotacao.projeto ?? null,
      });
    },
    clearProjetoProdutos(oldProjeto) {
      this.cotacao.produtos = this.cotacao.produtos.map((produto) => {
        const produtoProjetoId = produto.projeto ? produto.projeto.id : null;
        if (oldProjeto.id === produtoProjetoId) {
          return {
            ...produto,
            projeto: null,
          };
        }
        return { ...produto };
      });
    },
    setProjetoProdutos(oldProjeto, newProjeto) {
      this.cotacao.produtos = this.cotacao.produtos.map(produto => ({
        ...produto,
        projeto: this.getProjeto(produto, oldProjeto, newProjeto),
      }));
    },
    getProjeto(produto, oldProjeto, newProjeto) {
      const oldProjetoId = oldProjeto ? oldProjeto.id : null;
      if (produto.projeto === null || produto.projeto.id === oldProjetoId) {
        return newProjeto;
      }
      return produto.projeto;
    },
    clearCentroCustoProdutos(oldCentroCusto) {
      this.cotacao.produtos = this.cotacao.produtos.map((produto) => {
        const produtoCentroCustoId = produto.centroCusto ? produto.centroCusto.id : null;
        if (oldCentroCusto.id === produtoCentroCustoId) {
          return {
            ...produto,
            centroCusto: null,
          };
        }
        return { ...produto };
      });
    },
    setCentroCustoProdutos(oldCentroCusto, newCentroCusto) {
      this.cotacao.produtos = this.cotacao.produtos.map(produto => ({
        ...produto,
        centroCusto: this.getCentroCusto(produto, oldCentroCusto, newCentroCusto),
      }));
    },
    getCentroCusto(produto, oldCentroCusto, newCentroCusto) {
      const oldCentroCustoId = oldCentroCusto ? oldCentroCusto.id : null;
      if (produto.centroCusto === null || produto.centroCusto.id === oldCentroCustoId) {
        return newCentroCusto;
      }
      return produto.centroCusto;
    },
    removeProduto(index) {
      if (this.cotacao.produtos.length <= 1) {
        return;
      }
      this.cotacao.produtos.splice(index, 1);
    },
    setupProdutos() {
      const produtos = [...this.cotacao.produtos];
      if (!produtos || !produtos.length) {
        this.cotacao.produtos = [{
          ...initalState(),
          $$id: this.idGenerator(),
          centroCusto: this.cotacao.centroCusto,
          projeto: this.cotacao.projeto,
        }];
        return;
      }
      this.cotacao.produtos = produtos.map(produto => ({
        ...produto,
        id: undefined,
        $$id: this.idGenerator(),
      }));
    },
    onFileLoad(produto, loading) {
      // eslint-disable-next-line no-param-reassign
      produto.$$hasFileLoading = loading;
    },
  },
  computed: {
    hasFileLoading() {
      return !isEmpty(this.cotacao.produtos.filter(p => p.$$hasFileLoading));
    },
    hasQuantidadeProduto() {
      return !isEmpty(this.cotacao.produtos.find(p => p.quantidade <= 0));
    },
    getPrecision() {
      return item => getPrecision(item);
    },
  },
  created() {
    this.setupProdutos();
  },
  validations: {
    cotacao: {
      produtos: {
        $each: {
          produto: {
            required,
          },
          quantidade: {
            required,
          },
          unidadeMedida: {
            id: {
              required,
            },
          },
        },
      },
    },
  },
  watch: {
    'cotacao.projeto': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue === undefined && oldValue) {
        this.clearProjetoProdutos(oldValue);
        return;
      }
      this.setProjetoProdutos(oldValue, newValue);
    },
    'cotacao.centroCusto': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue === undefined && oldValue) {
        this.clearCentroCustoProdutos(oldValue);
        return;
      }
      this.setCentroCustoProdutos(oldValue, newValue);
    },
  },
};
</script>

<style scoped>
.table-line {
  min-height: 55px;
  height: 55px
}

.produtos-table tr:hover:not(.v-table__expanded__content) {
  background: white !important;
}
</style>
